import { makeStyles } from '@material-ui/styles'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import { GRIN_ALL_INCLUSIVE_GROUP, GRIN_SUBSCRIPTION_GROUP } from 'consts/grinPlanConsts'
import useClinic from 'hooks/useClinic'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ScopesDiscountSubV3 from 'resources/scope-discount-subscription-v3.png'

const useStyles = makeStyles({
  discountImage: {
    display: 'block',
    width: '100%',
    maxWidth: 560,
    height: 'auto',
    alignSelf: 'center',
    flexShrink: 0
  }
})

const OrderExtraInfo = ({ grinPlanGroup, shippingFee }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { hasFreeScopes } = useClinic()

  const hasAnyDiscount =
    (grinPlanGroup?.includes(GRIN_SUBSCRIPTION_GROUP) || grinPlanGroup?.includes(GRIN_ALL_INCLUSIVE_GROUP)) &&
    !hasFreeScopes

  return hasAnyDiscount ? (
    <img className={classes.discountImage} src={ScopesDiscountSubV3} alt="" />
  ) : (
    <DazzedParagraph12 className={classes.note}>
      {t('dialogs.orderScopes.shippingFeeText1')}
      <span className={classes.currencyPrefix}>&nbsp;$</span>
      {t('dialogs.orderScopes.shippingFeeText2', {
        fee: `${shippingFee} USD`
      })}
    </DazzedParagraph12>
  )
}

export default OrderExtraInfo
